import { render } from "./SectionPageShell.vue?vue&type=template&id=11895508"
import script from "./SectionPageShell.vue?vue&type=script&lang=js"
export * from "./SectionPageShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__